import { pbrAxios } from '../../common/js/pbrAxios'

/**
 * 项目详情下项目，企业，行业的图谱接口
 * @param {Object}params
 *  @param {String}params.id: id初始时为项目id，行业id，企业id，点击时为节点的id
 *  @param {String}params.conceptId: 对应概念图谱id，1:国家 2:城市 3:行业  4:企业 5:执行机构 6:项目
 *  @param {String}params.tag: 判断是否点击 0：点击时传递的值，1：初始值
 * @returns {AxiosPromise<any>}
 */
const getRelationMapProject = params => pbrAxios.get('/front/project/relationMapInitProject',{params})

/**
 * 资讯详情页-图谱
 * @param {Object}params
 *  @param {String}params.id: id,初始时为资讯id，点击时为节点id
 *  @param {String}params.conceptId: 初始时为4 ，点击时为对应的conceptId
 *  @param {String}params.tag: 判断是否点击 0：点击时传递的值，1：初始值
 * @returns {AxiosPromise<any>}
 */
const getRelationMapInfos = params => pbrAxios.get('/front/article/relationMapInfos',{params})

/**
 * 风险事件页面对应的图谱接口
 * @param {Object}params
 *  @param {String}params.id: 初始值为风险id，点击节点时为节点id
 *  @param {String}params.conceptId: 初始值为1 国家，点击时为对应的conceptId
 *  @param {String}params.tag: 判断是否点击 0：点击时传递的值，1：初始值
 *  @param {String}params.lang: 语言类型默认为cn
 * @returns {AxiosPromise<any>}
 */
const getRelationMapRisk = params => pbrAxios.get('/front/risk/relationMapRisk',{params})

/**
 * 分析页图谱
 * @param {Object}params
 *  @param {String}params.id: 当选择国家时  国家id逗号隔开  ；查询节点时传节点的id
 *  @param {String}params.conceptId: 对应概念图谱id，1:国家 2:城市 3:行业  4:企业 5:执行机构 6:项目
 *  @param {String}params.tag: 判断是否点击 0：点击时传递的值，1：初始值
 *  @param {String}params.ids: 搜索时传入的国家id以逗号分隔
 * @returns {AxiosPromise<any>}
 */
const getRelationMapAnalysis = params => pbrAxios.get('/front/analyses/relationMapAnalys',{params})

/**
 * 企业详情页的图谱接口
 * @param {Object}params
 *  @param {String}params.id: 初始时接口的id为企业id
 *  @param {String}params.conceptId: 初始时conceptId=5
 *  @param {String}params.tag: 初始时tag=1 点击时tag=0
 * @returns {AxiosPromise<any>}
 */
const getRelationMapEnterprise = params => pbrAxios.get('/front/enterprise/relationMapEnterprise',{params})



const getRelationMapSpecialNews = params => pbrAxios.get('/front/special/relationMapSpecialNews', {params})

export default {
  getRelationMapProject,
  getRelationMapInfos,
  getRelationMapRisk,
  getRelationMapAnalysis,
  getRelationMapEnterprise,
  getRelationMapSpecialNews
}
